/**
 * Non-paying members see predictions for this gameweek only; every other
 * gameweek's predictions show a padlock. Gameweek one is the free taster so
 * new visitors can see the tool working before they join.
 */
export const FREE_PREDICTIONS_GAMEWEEK = 1;

/**
 * FFH-2373 analytics placement, shared by the recommend-transfer action in
 * the player info modal and the padlock that replaces it for free users.
 */
export const RECOMMEND_TRANSFER_PLACEMENT = 'pick_player_info_modal';
